import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

export const Landing: React.FC = () => {
  const navigate = useNavigate();
  const { isAuthenticated, user } = useAuth();
  const isAnalystRole = user?.role === 'analyst' || user?.role === 'ANALYST';

  // If already authenticated, redirect to appropriate dashboard
  useEffect(() => {
    if (isAuthenticated) {
      if (isAnalystRole) {
        navigate('/dashboard/analyst');
      } else {
        navigate('/dashboard');
      }
    }
  }, [isAuthenticated, isAnalystRole, navigate]);

  // Show landing content in iframe so URL stays / (no landing.html in address bar)
  if (!isAuthenticated) {
    return (
      <iframe
        title="CONVPILOT Landing"
        src="/landing.html"
        style={{
          position: 'fixed',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          border: 'none',
          display: 'block',
        }}
      />
    );
  }

  return null;
};

